import {
  AlertTriangle,
  Edit,
  Edit2,
  Loader,
  Loader2,
  PlusSquare,
  ReceiptIcon,
  SearchCheck,
  User,
  User2,
  UserCheck,
  UserCheck2,
} from "lucide-react";
import React, { useState } from "react";
import {
  createBilling,
  deleteBilling,
  listBilling,
  updateBilling,
  viewBilling,
} from "../../services/apiService";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import { useEffect } from "react";
import BillingTable from "../../components/Billing/BillingTable";
import { searchUsers } from "../../services/EmailService.js/emailService";
import SearchData from "../../components/Billing/SearchData";
import BillingDetailsModal from "../../components/Billing/BillingDetailsModal";
import ConfirmModal from "../../components/Billing/ConfirmModal";

function BillingMaster() {
  const [masterType, setMasterType] = useState("all_users");
  const [status, setStatus] = useState(true);
  const [amount, setAmount] = useState("");
  const [list, setList] = useState(null);
  const [formType, setFormType] = useState("create");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchInput, setSearchInput] = useState(null);
  const [searchResponse, setSearchResponse] = useState(null);
  const [editClicked, setEditClicked] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [inputError, setInputError] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [viewResponse, setViewResponse] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [checkBillLoading, setCheckBillLoading] = useState(false);
  const [reportLoading, setReportLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [checkBillResponse, setCheckBillResponse] = useState(null);
  const [searchedUser, setSearchedUser] = useState(null);

  const handleCreate = async () => {
    let payload;
    payload = {
      is_active: status,
      master_type: masterType,
      min_bill_amount: amount,
    };

    if (masterType === "user") {
      payload.user_id = searchedUser?.user_id?.slice(4);
    }

    if (masterType === "user" && !payload?.user_id) {
      return setInputError("please select user");
    } else if (!amount) {
      return setInputError("please select Minimum Bill Amount");
    }

    setInputError("");
    setLoading(true);

    try {
      const res = await createBilling(payload);

      if (
        res?.status?.code === 201 ||
        res?.data?.status?.code === 201 ||
        res?.status?.code === 200 ||
        res?.data?.status?.code === 200
      ) {
        showSuccessToast(res?.message || res?.data?.message);
        setAmount("");
        setSearchResponse("");
        setSelectedUser(null);
        setSearchedUser("");
      } else {
        showErrorToast(res?.data?.message || res?.data?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async () => {
    let payload;
    payload = {
      is_active: status,
      master_type: masterType,
      min_bill_amount: amount,
    };

    if (masterType === "user") {
      payload.user_id = selectedUser?.user_id;
    }

    if (masterType === "user" && !selectedUser?.user_id) {
      return setInputError("please select user");
    } else if (!amount) {
      return setInputError("please select Minimum Bill Amount");
    }

    setInputError("");
    setLoading(true);

    try {
      const res = await updateBilling(payload);

      if (res) {
        console.log(res);
      }

      if (res?.status?.code === 200 || res?.data?.status?.code === 200) {
        showSuccessToast(
          res?.message || res?.data?.message || "Updated successfully",
        );
        setAmount("");
        setSearchInput("");
        setSearchResponse("");
        setSelectedUser(null);
        setSearchedUser("");
        setFormType("create");
      } else {
        showErrorToast(res?.data?.message || res?.data?.data?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (item) => {
    setFormType("update");
    setEditClicked(true);
    setAmount(item?.min_bill_amount);
    setMasterType(item?.master_type);
    setStatus(item?.is_active);

    if (item.master_type === "user") {
      const id = String(item?.user_id);

      setSearchInput(id.length === 3 ? "APID0" + id : "APID" + id);
    }

    console.log(item?.user_id);
  };

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteBilling(itemToDelete?.id);

      if (res) {
        console.log(res);
      }
      if (res?.status?.code === 200 || res?.data?.status?.code === 200) {
        setShowConfirmationModal(false);
        showSuccessToast(
          res?.message || res?.data?.message || "deleted successfully",
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowConfirmationModal(true);
  };

  const handleView = async (item) => {
    let payload;
    payload = {
      master_type: item.master_type,
    };

    if (item.master_type === "user") payload.user_id = item?.user_id;

    setViewLoading(true);

    try {
      const res = await viewBilling(payload);
      if (res?.status?.code === 200) {
        setViewResponse(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setViewLoading(false);
    }
  };

  const handleExit = () => {
    setFormType("create");
    setAmount("");
    setMasterType("all_users");
    setSelectedUser("");
    setStatus(true);
    setInputError("");
    setSearchResponse(null);
  };

  const getList = async () => {
    setReportLoading(true);
    try {
      const res = await listBilling({ page: currentPage });

      if (res?.status?.code === 200) {
        setList(res);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setReportLoading(false);
    }
  };

  const handleOnSelect = (data) => {
    setSearchedUser(data);

    if (searchedUser?.user_id === data.user_id) {
      setSearchedUser("");
    } else {
      setSearchedUser(data);
    }
  };

  const checkBilling = async () => {
    let payload;
    payload = {
      master_type: "user",
      user_id: searchedUser?.user_id?.slice(4),
    };

    // if (selectedUser?.master_type === "user") payload.user_id = selectedUser?.user_id;

    setCheckBillLoading(true);

    try {
      const res = await viewBilling(payload);
      if (res?.status?.code === 200) {
        setCheckBillResponse(res?.data);
        setSelectedUser(res?.data);
        setFormType("update");
        setMasterType(res?.data?.master_type);
        setAmount(res?.data?.min_bill_amount);
      } else {
        setSelectedUser("");
        setFormType("create");
        setAmount("");
        showErrorToast(res?.message || res?.data?.message || "not found");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCheckBillLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, [currentPage]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput);
    }, 500); // 500ms delay

    return () => clearTimeout(timer);
  }, [searchInput]);

  useEffect(() => {
    const handleSearch = async () => {
      if (!debouncedSearch) return;

      setSearchLoading(true);

      try {
        const res = await searchUsers({ search: debouncedSearch });
        if (res) {
          setSearchResponse(res);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setSearchLoading(false);
      }
    };

    handleSearch();
  }, [debouncedSearch]);

  useEffect(() => {
    if (!searchedUser?.user_id) return;
    checkBilling();
  }, [searchedUser?.user_id]);

  useEffect(() => {
    let timeOut;

    if (!editClicked) return;
    const el = document.getElementById("scrollIntoView");

    el.scrollIntoView({ behavior: "smooth" });

    timeOut = setTimeout(() => {
      setEditClicked(false);
    }, 200);

    return () => {
      clearTimeout(timeOut);
    };
  }, [editClicked]);

  useEffect(() => {
    if (masterType === "user") return;
    setSearchResponse(null);
    setSelectedUser("");
    setSearchedUser("");
  }, [masterType]);
  return (
    <div className="min-h-screen w-full bg-slate-100 flex justify-start items-center flex-col pt-14 p-2 md:p-8">
      <div id="scrollIntoView" />
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-blue-600 text-white p-3 rounded-lg">
          <ReceiptIcon size={22} />
        </div>

        <div>
          <h1 className="text-2xl font-bold text-slate-800">Billing Master</h1>
          <p className="text-sm text-slate-500">
            Configure billing rules and minimum bill amount
          </p>
        </div>
      </div>

      {/* Card */}
      <div className="bg-white w-full rounded-xl relative shadow-sm border border-slate-200 p-8 max-w-5xl space-y-8">
        {/* Master Type */}

        <div className="absolute top-2 flex gap-2 items-center right-2">
          {formType === "update" && (
            <button
              onClick={handleExit}
              className="bg-red-100 font-semibold text-sm text-red-800 rounded-full px-4 py-2"
            >
              exit{" "}
            </button>
          )}
          {formType === "create" ? (
            <>
              <span className="flex text-sm bg-blue-100 font-semibold text-blue-800 rounded-full px-4 py-2 items-center gap-2">
                <PlusSquare />
                Create Mode
              </span>
            </>
          ) : (
            <>
              <span className="flex text-sm bg-amber-100 font-semibold text-amber-800 rounded-full px-4 py-2 items-center gap-2">
                <Edit />
                Edit Mode
              </span>
            </>
          )}
        </div>
        <div className="m-0">
          <label className="block text-sm font-semibold text-slate-700 mb-3">
            Master Type
          </label>

          <div className="bg-slate-100 p-1 rounded-lg flex w-fit">
            <button
              onClick={() => setMasterType("all_users")}
              className={`px-6 py-2 rounded-md text-sm font-medium transition
              ${
                masterType === "all_users"
                  ? "bg-white shadow text-blue-600"
                  : "text-slate-500"
              }`}
            >
              All Users
            </button>

            <button
              onClick={() => setMasterType("user")}
              className={`px-6 py-2 rounded-md text-sm font-medium transition
              ${
                masterType === "user"
                  ? "bg-white shadow text-blue-600"
                  : "text-slate-500"
              }`}
            >
              Specific User
            </button>
          </div>
        </div>

        <div className="flex flex-col items-start md:flex-row md:items-center gap-4">
          {/* User ID */}
          {masterType === "user" && (
            <div className="flex flex-col gap-4">
              <div>
                <label className=" text-sm flex gap-2 items-center justify-between font-semibold text-slate-700 mb-2">
                  Search User ID
                  {searchLoading && (
                    <Loader2 className="text-blue-600 animate-spin" />
                  )}
                </label>

                <input
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  placeholder="Enter user id"
                  className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>
            </div>
          )}

          {/* Amount */}
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Minimum Bill Amount
            </label>

            <input
              value={amount}
              required
              onChange={(e) => setAmount(e.target.value)}
              type="number"
              placeholder="Enter minimum amount"
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {searchResponse && (
            <SearchData
              onSelect={handleOnSelect}
              searchResponse={searchResponse}
              searchedUser={searchedUser}
            />
          )}

          {selectedUser && searchedUser && (
            <div
              className={` w-full bg-white border  ${checkBillResponse?.min_bill_amount ? " border-blue-200" : " border-green-200 "} rounded-xl shadow-sm overflow-hidden`}
            >
              {/* Header */}
              <div
                className={`flex items-center gap-2 px-4 py-2  ${checkBillResponse?.min_bill_amount ? "bg-blue-50 border-b border-blue-200 text-blue-700" : "bg-green-50 border-b border-green-200 text-green-700"} font-semibold text-sm`}
              >
                <UserCheck2 size={18} />
                {checkBillLoading ? (
                  <Loader2 className="text-blue-600 animate-spin" />
                ) : (
                  "Selected User"
                )}
              </div>

              {/* Body */}
              <div className="px-4 pb-4 pt-2 flex gap-4">
                {/* Avatar */}

                {/* User Info */}
                <div className="grid grid-cols-1 gap-x-6 gap-y-2 text-sm w-full">
                  <div className="flex items-center justify-center gap-3">
                    <div
                      className={`flex items-center w-12 h-12 justify-center rounded-full   ${checkBillResponse?.min_bill_amount ? "bg-blue-100 text-blue-700" : "bg-green-100  text-green-700"}`}
                    >
                      <User size={22} />
                    </div>
                    <div>
                      <span className="text-slate-500">Name</span>
                      <div className="font-medium text-slate-700">
                        {searchedUser?.name || "N/A"}
                      </div>
                    </div>
                  </div>

                  <div>
                    <span className="text-slate-500">User ID</span>
                    <div className="font-medium text-slate-700">
                      {selectedUser?.user_id}
                    </div>
                  </div>

                  <div>
                    <span className="text-slate-500">Mobile</span>
                    <div className="font-medium text-slate-700">
                      {searchedUser?.mobile_number || "N/A"}
                    </div>
                  </div>

                  <div>
                    <span className="text-slate-500 text-wrap">Email</span>
                    <div className="font-medium text-slate-700">
                      {searchedUser?.email_address || "N/A"}
                    </div>
                  </div>

                  {checkBillResponse?.min_bill_amount && (
                    <div>
                      <span className="text-slate-500 text-wrap">
                        Minimum Bill Amount
                      </span>
                      <div className="font-medium text-slate-700">
                        {checkBillResponse?.min_bill_amount}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Status */}
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-sm font-semibold text-slate-700">
              Billing Status
            </h3>
            <p className="text-xs text-slate-500">
              Enable or disable billing rule
            </p>
          </div>

          <button
            onClick={() => setStatus(!status)}
            className={`w-12 h-6 flex items-center rounded-full p-1 transition
            ${status ? "bg-blue-600 justify-end" : "bg-slate-300 justify-start"}`}
          >
            <span className="bg-white w-4 h-4 rounded-full shadow"></span>
          </button>
        </div>

        {/* Submit */}
        <div className="pt-4 border-t border-slate-200">
          {inputError && (!selectedUser?.user_id || !amount) && (
            <div className="text-red-700 mb-2 flex gap-2 items-center">
              <AlertTriangle size={18} />
              {inputError}
            </div>
          )}
          <button
            disabled={loading}
            onClick={formType === "create" ? handleCreate : handleUpdate}
            className={`px-6 py-2 rounded-lg text-sm disabled:opacity-70 font-medium shadow-sm transition ${formType === "create" ? "bg-blue-600 hover:bg-blue-700 text-white " : "bg-yellow-500 hover:bg-yellow-700 text-black "}`}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                Please wait <Loader2 className=" animate-spin" />
              </div>
            ) : formType === "create" ? (
              "Create Billing Rule"
            ) : (
              "Update Billing Rule"
            )}
          </button>
        </div>
      </div>

      <BillingDetailsModal
        open={viewResponse}
        data={viewResponse}
        onClose={() => setViewResponse(null)}
      />

      <ConfirmModal
        isOpen={showConfirmationModal}
        onConfirm={handleDelete}
        onCancel={() => setShowConfirmationModal(false)}
        loading={isDeleting}
      />

      <BillingTable
        data={list}
        onEdit={handleEditClick}
        onView={handleView}
        viewLoading={viewLoading}
        onDelete={handleDeleteClick}
        currentPage={currentPage}
        increasePage={() => setCurrentPage((prev) => prev + 1)}
        decreasePage={() => setCurrentPage((prev) => prev - 1)}
        reportLoading={reportLoading}
      />
    </div>
  );
}

export default BillingMaster;
